
import S3 from 'aws-sdk/clients/s3';
import https from "https"
// const OSSURL = 'https://vp-dev.chefdigital.io'
const ossClient = new S3({
    accessKeyId: "AKIAU3VOTTKPIUWQS6XG",
    secretAccessKey: "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",
    region: "ap-east-1"
});
const S3BUCKET = "ive-prod";

export const fetchBlob = (url) => {
    return fetch(url).then(res => res.blob())
}

export const uploadToS3 = async (link, name) => {
    try {
        const currBlob = await fetchBlob(link)
        const result = await new Promise((resolve, reject) => {
            ossClient.upload({
                Bucket: S3BUCKET,
                Key: `upload/usermodel/${name}.glb`,
                Body: new File([currBlob], `/${name}.glb`)
            }, { partSize: 30 * 1024 * 1024, queueSize: 4 }, (err, data) => {
                resolve(data)
            });
        });
        return `https://ive.chefdigital.io/upload/usermodel/${name}.glb`;
    } catch (e) {
        console.log('error', e)
    }
}